export default __webpack_public_path__ + "static/sponsors_plant-ac6976e915ea7e3b0011fb99ec0e7481.png";